module.exports = __webpack_public_path__ + "sam-0e5b2e6435cab563ecd7118bfe1e6846.webp";